export const NAV_MENU = "NAV_MENU"

export const HOTEL = "HOTEL"
export const HOTEL_SUCCESS = "HOTEL_SUCCESS"
export const HOTEL_FAIL = "HOTEL_FAIL"

export const RESTAURANT = "RESTAURANT"
export const RESTAURANT_SUCCESS = "RESTAURANT_SUCCESS"
export const RESTAURANT_FAIL = "RESTAURANT_FAIL"



export const SELECTED_LOCATION = "SELECTED_LOCATION"
export const SELECTED_LOCATION_TYPE = "SELECTED_LOCATION_TYPE"

export const LOCATION = "LOCATION"
export const LOCATION_SUCCESS = "LOCATION_SUCCESS"
export const LOCATION_FAIL = "LOCATION_FAIL"

export const SEARCH_SUGGUESTION = "SEARCH_SUGGUESTION"
export const SEARCH_SUGGUESTION_SUCCESS = "SEARCH_SUGGUESTION_SUCCESS"
export const SEARCH_SUGGUESTION_FAIL = "SEARCH_SUGGUESTION_FAIL"

export const USER = "USER"
export const USER_SUCCESS = "USER_SUCCESS"
export const USER_FAIL = "USER_FAIL"

export const LOGOUT = "LOGOUT"
export const LOGOUT_FAIL = "LOGOUT_FAIL"
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS"
export const FIRE_BASE_INIT = "FIRE_BASE_INIT"
export const FIRE_BASE_INIT_STATE = "FIRE_BASE_INIT_STATE"
export const REDIRECT = "REDIRECT"

export const PENDING_NUMBER = "PENDING_NUMBER"



export const RECENT_PLACE = "RECENT_PLACE"
export const RECENT_PLACE_SUCCESS = "RECENT_PLACE_SUCCESS"
export const RECENT_PLACE_FAIL = "RECENT_PLACE_FAIL"

export const SAVE_TOKEN = "SAVE_TOKEN"
export const CODE_CHECKED = "CODE_CHECKED"
export const BTN_STATE = "BTN_STATE"
export const LOGIN = "LOGIN"
export const LOGIN_FAIL = "LOGIN_FAIL"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"

export const SET_LOCALE = "SET_LOCALE"

export const CATEGORY = "CATEGORY"
export const CATEGORY_SUCCESS = "CATEGORY_SUCCESS"
export const CATEGORY_FAIL = "CATEGORY_FAIL"


export const ITEM = "ITEM"
export const ITEM_SUCCESS = "ITEM_SUCCESS"
export const ITEM_FAIL = "ITEM_FAIL"

export const ORDER = "ORDER"
export const ORDER_REMOVE = "ORDER_REMOVE"
export const ORDER_PENDING = "ORDER_PENDING"

export const SUBMIT_ORDER = "SUBMIT_ORDER"
export const SUBMIT_ORDER_SUCCESS = "SUBMIT_ORDER_SUCCESS"
export const SUBMIT_ORDER_FAIL = "SUBMIT_ORDER_FAIL"

export const SELETED_CURRENCY = "SELETED_CURRENCY"

export const LANGUAGUES = "LANGUAGUES"
export const LANGUAGUES_SUCCESS = "LANGUAGUES_SUCCESS"
export const LANGUAGUES_FAIL = "LANGUAGUES_FAIL"

export const COUPON = "COUPON"
export const COUPON_SUCCESS = "COUPON_SUCCESS"
export const COUPON_FAIL = "COUPON_FAIL"


export const ORDERS = "ORDERS"
export const ORDERS_SUCCESS = "ORDERS_SUCCESS"
export const ORDERS_FAIL = "ORDERS_FAIL"


export const RATE = "RATE"
export const RATE_SUCCESS = "RATE_SUCCESS"
export const RATE_FAIL = "RATE_FAIL"

export const SALE_ID = "SALE_ID"
export const ORDER_COMPLETED = "ORDER_COMPLETED"
export const TOGGLE_CURRENCY = "TOGGLE_CURRENCY"

export const ORDERINFOR = "ORDERINFOR"


export const PROMOTION = "PROMOTION"
export const PROMOTION_SUCCESS = "PROMOTION_SUCCESS"
export const PROMOTION_FAIL = "PROMOTION_FAIL"


export const APPLY_PROMOTION = "APPLY_PROMOTION"

export const CALC_PROMOTION = "CALC_PROMOTION"
export const CALC_PROMOTION_FAIL = "CALC_PROMOTION_FAIL"
export const CALC_PROMOTION_SUCCESS = "CALC_PROMOTION_SUCCESS"

export const CALC_DILIVERY = "CALC_DILIVERY"
export const CALC_DILIVERY_FAIL = "CALC_DILIVERY_FAIL"
export const CALC_DILIVERY_SUCCESS = "CALC_DILIVERY_SUCCESS"

export const SALE_DETAIL = "SALE_DETAIL"
export const SALE_DETAIL_FAIL = "SALE_DETAIL_FAIL"
export const SALE_DETAIL_SUCCESS = "SALE_DETAIL_SUCCESS"

